import type { LocaleMessageBundle } from '../../types'

export const printTemplateMessages: LocaleMessageBundle = {
  vi: {
    'setting.printTemplate.title': 'Mẫu in hóa đơn',
    'setting.printTemplate.subtitle': 'Thiết kế giao diện in theo từng loại chứng từ và khổ giấy',
    'setting.printTemplate.actions.save': 'Lưu mẫu',
    'setting.printTemplate.actions.reset': 'Khôi phục mặc định',
    'setting.printTemplate.actions.printSample': 'In thử',
    'setting.printTemplate.actions.reload': 'Tải lại',
    'setting.printTemplate.preview.title': 'Xem trước',
    'setting.printTemplate.preview.paperSize': 'Khổ xem trước',
    'setting.printTemplate.editor.paperSize': 'Khổ giấy mặc định',
    'setting.printTemplate.editor.layout': 'Bố cục',
    'setting.printTemplate.editor.fontSize': 'Cỡ chữ',
    'setting.printTemplate.editor.showLogo': 'Hiện logo',
    'setting.printTemplate.editor.showShopName': 'Hiện tên cửa hàng',
    'setting.printTemplate.editor.showBranchInfo': 'Hiện thông tin chi nhánh',
    'setting.printTemplate.editor.showSignatures': 'Hiện chữ ký',
    'setting.printTemplate.editor.showPaymentQr': 'Hiện QR chuyển khoản',
    'setting.printTemplate.paymentQr.scan': 'Quét QR để chuyển khoản',
    'setting.printTemplate.paymentQr.alt': 'QR chuyển khoản',
    'setting.printTemplate.paymentQr.account': 'STK',
    'setting.printTemplate.paymentQr.content': 'Nội dung',
    'setting.printTemplate.paymentQr.missingBank':
      'Cần cấu hình một tài khoản mặc định đang hoạt động và có VietQR BIN hợp lệ.',
    'setting.printTemplate.editor.headerText': 'Dòng phụ header',
    'setting.printTemplate.editor.footerText': 'Footer / lời cảm ơn',
    'setting.printTemplate.editor.fields': 'Trường hiển thị',
    'setting.printTemplate.editor.section.general': 'Chung',
    'setting.printTemplate.editor.section.header': 'Thông tin phiếu',
    'setting.printTemplate.editor.section.items': 'Cột sản phẩm',
    'setting.printTemplate.editor.section.totals': 'Tổng kết',
    'setting.printTemplate.editor.section.payment': 'Thanh toán',
    'setting.printTemplate.layouts.compact': 'Gọn',
    'setting.printTemplate.layouts.standard': 'Tiêu chuẩn',
    'setting.printTemplate.layouts.detailed': 'Chi tiết',
    'setting.printTemplate.fontSizes.small': 'Nhỏ',
    'setting.printTemplate.fontSizes.medium': 'Vừa',
    'setting.printTemplate.fontSizes.large': 'Lớn',
    'setting.printTemplate.paperSizes.58mm': 'Nhiệt 58mm',
    'setting.printTemplate.paperSizes.80mm': 'Nhiệt 80mm',
    'setting.printTemplate.paperSizes.A4': 'A4',
    'setting.printTemplate.documentTypes.purchase_receipt': 'Phiếu nhập hàng',
    'setting.printTemplate.documentTypes.purchase_return': 'Phiếu trả hàng nhập',
    'setting.printTemplate.documentTypes.sales_invoice': 'Hóa đơn bán hàng',
    'setting.printTemplate.documentTypes.pos_bill': 'Bill POS',
    'setting.printTemplate.documentTypes.sales_order': 'Phiếu đặt hàng',
    'setting.printTemplate.documentTypes.production_order': 'Phiếu sản xuất',
    'setting.printTemplate.documentTypes.inventory_check': 'Phiếu kiểm kho',
    'setting.printTemplate.titles.purchase_receipt': 'PHIẾU NHẬP HÀNG',
    'setting.printTemplate.titles.purchase_return': 'PHIẾU TRẢ HÀNG NHẬP',
    'setting.printTemplate.titles.sales_invoice': 'HÓA ĐƠN BÁN HÀNG',
    'setting.printTemplate.titles.pos_bill': 'HÓA ĐƠN TẠM TÍNH',
    'setting.printTemplate.titles.sales_order': 'PHIẾU ĐẶT HÀNG',
    'setting.printTemplate.fields.code': 'Mã phiếu',
    'setting.printTemplate.fields.date': 'Ngày',
    'setting.printTemplate.fields.branch': 'Chi nhánh',
    'setting.printTemplate.fields.creator': 'Người tạo',
    'setting.printTemplate.fields.note': 'Ghi chú',
    'setting.printTemplate.fields.supplier': 'Nhà cung cấp',
    'setting.printTemplate.fields.supplier_invoice_no': 'Số HĐ NCC',
    'setting.printTemplate.fields.source_receipt_code': 'Phiếu nhập gốc',
    'setting.printTemplate.fields.customer': 'Khách hàng',
    'setting.printTemplate.fields.seller': 'Nhân viên bán',
    'setting.printTemplate.fields.delivery_date': 'Ngày giao',
    'setting.printTemplate.fields.delivery_time': 'Khung giờ giao',
    'setting.printTemplate.fields.recipient': 'Người nhận & Địa chỉ',
    'setting.printTemplate.fields.delivery_partner': 'Đơn vị vận chuyển',
    'setting.printTemplate.fields.table': 'Bàn',
    'setting.printTemplate.fields.play_time': 'Thời gian chơi',
    'setting.printTemplate.fields.table_transfer': 'Lịch sử đổi/gộp bàn',
    'setting.printTemplate.fields.started_at': 'Vào lúc',
    'setting.printTemplate.fields.play_duration': 'Thời lượng',
    'setting.printTemplate.fields.player': 'Người chơi',
    'setting.printTemplate.fields.table_time': 'Tiền giờ bàn',
    'setting.printTemplate.fields.current_table_time': 'Tiền bàn hiện tại',
    'setting.printTemplate.fields.player_summary': 'Tổng theo người',
    'setting.printTemplate.fields.no': 'STT',
    'setting.printTemplate.fields.product_code': 'Mã hàng',
    'setting.printTemplate.fields.product_name': 'Tên hàng',
    'setting.printTemplate.fields.line_note': 'Ghi chú SP',
    'setting.printTemplate.fields.unit': 'ĐVT',
    'setting.printTemplate.fields.quantity': 'SL',
    'setting.printTemplate.fields.unit_price': 'Đơn giá',
    'setting.printTemplate.fields.return_price': 'Giá trả',
    'setting.printTemplate.fields.line_discount': 'CK dòng',
    'setting.printTemplate.fields.line_total': 'Thành tiền',
    'setting.printTemplate.fields.combo_groups': 'Nhóm combo',
    'setting.printTemplate.fields.subtotal': 'Tổng tiền hàng',
    'setting.printTemplate.fields.discount': 'Chiết khấu',
    'setting.printTemplate.fields.voucher': 'Mã giảm giá',
    'setting.printTemplate.fields.tax': 'Thuế / VAT',
    'setting.printTemplate.fields.total': 'Tổng cộng',
    'setting.printTemplate.fields.shipping_fee': 'Phí vận chuyển',
    'setting.printTemplate.fields.shipping_fee_payer': 'Bên trả phí vận chuyển',
    'setting.printTemplate.fields.customer_shipping_amount': 'Phần phí khách trả',
    'setting.printTemplate.fields.shop_shipping_amount': 'Phần phí cửa hàng trả',
    'setting.printTemplate.shippingPayer.customer': 'Khách trả',
    'setting.printTemplate.shippingPayer.shop': 'Cửa hàng trả',
    'setting.printTemplate.shippingPayer.shared': 'Cùng trả',
    'setting.printTemplate.fields.paid_amount': 'Đã thanh toán',
    'setting.printTemplate.fields.point_payment': 'Điểm (số điểm)',
    'setting.printTemplate.labels.pointPayment': 'Điểm ({points})',
    'setting.printTemplate.fields.debt_amount': 'Còn nợ',
    'setting.printTemplate.fields.remaining_amount': 'Còn lại',
    'setting.printTemplate.fields.payment_method': 'PTTT',
    'setting.printTemplate.fields.cod_amount': 'Tiền thu hộ (COD)',
    'setting.printTemplate.fields.debt_reduced': 'Giảm công nợ',
    'setting.printTemplate.fields.supplier_credit': 'NCC cần trả',
    'setting.printTemplate.fields.system_quantity': 'Tồn hệ thống',
    'setting.printTemplate.fields.actual_quantity': 'Thực tế',
    'setting.printTemplate.fields.difference_quantity': 'SL chênh lệch',
    'setting.printTemplate.fields.cost_price': 'Giá vốn',
    'setting.printTemplate.fields.difference_value': 'Giá trị chênh lệch',
    'setting.printTemplate.fields.item_status': 'Trạng thái',
    'setting.printTemplate.itemStatuses.matched': 'Khớp',
    'setting.printTemplate.itemStatuses.different': 'Lệch',
    'setting.printTemplate.itemStatuses.unchecked': 'Chưa kiểm',
    'setting.printTemplate.itemStatuses.excess': 'Thừa',
    'setting.printTemplate.itemStatuses.shortage': 'Thiếu',
    'setting.printTemplate.itemStatuses.draft': 'Nháp',
    'setting.printTemplate.itemStatuses.balanced': 'Đã cân bằng',
    'setting.printTemplate.itemStatuses.cancelled': 'Đã hủy',
    'setting.printTemplate.fields.total_items': 'Tổng mặt hàng',
    'setting.printTemplate.fields.checked_items': 'Số mặt hàng đã kiểm',
    'setting.printTemplate.fields.unchecked_items': 'Số mặt hàng chưa kiểm',
    'setting.printTemplate.fields.difference_quantity_total': 'Tổng SL chênh lệch',
    'setting.printTemplate.fields.difference_value_total': 'Tổng giá trị chênh lệch',
    'setting.printTemplate.labels.shopDefault': 'CỬA HÀNG',
    'setting.printTemplate.labels.address': 'Địa chỉ',
    'setting.printTemplate.labels.phone': 'Điện thoại',
    'setting.printTemplate.labels.totalProducts': 'Tổng số mặt hàng',
    'setting.printTemplate.labels.tableTransferTime': 'Thời gian',
    'setting.printTemplate.labels.tableTransferCheckIn': 'Giờ vào',
    'setting.printTemplate.labels.tableTransferCheckOut': 'Giờ ra',
    'setting.printTemplate.labels.tableTransferTotalMinutes': 'Tổng: {minutes} phút',
    'setting.printTemplate.labels.tableTransferAmount': 'Tiền bàn khi đổi',
    'setting.printTemplate.labels.voucherDiscount': 'Trong đó giảm theo mã',
    'setting.printTemplate.labels.splitCount': 'chia {count}',
    'setting.printTemplate.labels.hour': 'giờ',
    'setting.printTemplate.labels.minute': 'phút',
    'setting.printTemplate.labels.supplierSign': 'Nhà cung cấp',
    'setting.printTemplate.labels.customerSign': 'Khách hàng',
    'setting.printTemplate.labels.creatorSign': 'Người lập',
    'setting.printTemplate.labels.inventoryCheckSign': 'Người kiểm kho',
    'setting.printTemplate.labels.signNote': 'Ký và ghi rõ họ tên',
    'setting.printTemplate.labels.productionMaterials': 'Nguyên vật liệu cần dùng',
    'setting.printTemplate.labels.warehouseSign': 'Thủ kho',
    'setting.printTemplate.labels.defaultBadge': 'Mặc định',
    'setting.printTemplate.labels.customBadge': 'Đã tùy chỉnh',
    'setting.printTemplate.messages.saveSuccess': 'Đã lưu mẫu in',
    'setting.printTemplate.messages.resetSuccess': 'Đã khôi phục mẫu mặc định',
    'setting.printTemplate.errors.loadFailed': 'Không tải được mẫu in',
    'setting.printTemplate.errors.saveFailed': 'Lưu mẫu in thất bại',
    'setting.printTemplate.errors.resetFailed': 'Khôi phục mẫu in thất bại',
    'setting.printTemplate.errors.printFailed': 'In thất bại',
  },
  en: {
    'setting.printTemplate.title': 'Print templates',
    'setting.printTemplate.subtitle': 'Design print layouts by document type and paper size',
    'setting.printTemplate.actions.save': 'Save template',
    'setting.printTemplate.actions.reset': 'Restore defaults',
    'setting.printTemplate.actions.printSample': 'Print sample',
    'setting.printTemplate.actions.reload': 'Reload',
    'setting.printTemplate.preview.title': 'Preview',
    'setting.printTemplate.preview.paperSize': 'Preview paper',
    'setting.printTemplate.editor.paperSize': 'Default paper size',
    'setting.printTemplate.editor.layout': 'Layout',
    'setting.printTemplate.editor.fontSize': 'Font size',
    'setting.printTemplate.editor.showLogo': 'Show logo',
    'setting.printTemplate.editor.showShopName': 'Show shop name',
    'setting.printTemplate.editor.showBranchInfo': 'Show branch info',
    'setting.printTemplate.editor.showSignatures': 'Show signatures',
    'setting.printTemplate.editor.showPaymentQr': 'Show payment QR',
    'setting.printTemplate.paymentQr.scan': 'Scan QR to transfer',
    'setting.printTemplate.paymentQr.alt': 'Payment QR',
    'setting.printTemplate.paymentQr.account': 'Account',
    'setting.printTemplate.paymentQr.content': 'Content',
    'setting.printTemplate.paymentQr.missingBank':
      'Configure an active default bank account with a valid VietQR BIN.',
    'setting.printTemplate.editor.headerText': 'Header subtitle',
    'setting.printTemplate.editor.footerText': 'Footer / thank-you text',
    'setting.printTemplate.editor.fields': 'Visible fields',
    'setting.printTemplate.editor.section.general': 'General',
    'setting.printTemplate.editor.section.header': 'Document info',
    'setting.printTemplate.editor.section.items': 'Line columns',
    'setting.printTemplate.editor.section.totals': 'Totals',
    'setting.printTemplate.editor.section.payment': 'Payment',
    'setting.printTemplate.layouts.compact': 'Compact',
    'setting.printTemplate.layouts.standard': 'Standard',
    'setting.printTemplate.layouts.detailed': 'Detailed',
    'setting.printTemplate.fontSizes.small': 'Small',
    'setting.printTemplate.fontSizes.medium': 'Medium',
    'setting.printTemplate.fontSizes.large': 'Large',
    'setting.printTemplate.paperSizes.58mm': 'Thermal 58mm',
    'setting.printTemplate.paperSizes.80mm': 'Thermal 80mm',
    'setting.printTemplate.paperSizes.A4': 'A4',
    'setting.printTemplate.documentTypes.purchase_receipt': 'Purchase receipt',
    'setting.printTemplate.documentTypes.purchase_return': 'Purchase return',
    'setting.printTemplate.documentTypes.sales_invoice': 'Sales invoice',
    'setting.printTemplate.documentTypes.pos_bill': 'POS bill',
    'setting.printTemplate.documentTypes.sales_order': 'Sales order',
    'setting.printTemplate.titles.purchase_receipt': 'PURCHASE RECEIPT',
    'setting.printTemplate.titles.purchase_return': 'PURCHASE RETURN',
    'setting.printTemplate.titles.sales_invoice': 'SALES INVOICE',
    'setting.printTemplate.titles.pos_bill': 'TEMPORARY BILL',
    'setting.printTemplate.titles.sales_order': 'SALES ORDER',
    'setting.printTemplate.fields.code': 'Code',
    'setting.printTemplate.fields.date': 'Date',
    'setting.printTemplate.fields.branch': 'Branch',
    'setting.printTemplate.fields.creator': 'Created by',
    'setting.printTemplate.fields.note': 'Note',
    'setting.printTemplate.fields.supplier': 'Supplier',
    'setting.printTemplate.fields.supplier_invoice_no': 'Supplier invoice no.',
    'setting.printTemplate.fields.source_receipt_code': 'Source receipt',
    'setting.printTemplate.fields.customer': 'Customer',
    'setting.printTemplate.fields.seller': 'Seller',
    'setting.printTemplate.fields.delivery_date': 'Delivery date',
    'setting.printTemplate.fields.delivery_time': 'Delivery time',
    'setting.printTemplate.fields.recipient': 'Recipient & Address',
    'setting.printTemplate.fields.delivery_partner': 'Delivery partner',
    'setting.printTemplate.fields.table': 'Table',
    'setting.printTemplate.fields.play_time': 'Play time',
    'setting.printTemplate.fields.table_transfer': 'Table move/merge history',
    'setting.printTemplate.fields.started_at': 'Started at',
    'setting.printTemplate.fields.play_duration': 'Duration',
    'setting.printTemplate.fields.player': 'Player',
    'setting.printTemplate.fields.table_time': 'Table time fee',
    'setting.printTemplate.fields.current_table_time': 'Table time at current table',
    'setting.printTemplate.fields.player_summary': 'Per-player totals',
    'setting.printTemplate.fields.no': 'No.',
    'setting.printTemplate.fields.product_code': 'SKU',
    'setting.printTemplate.fields.product_name': 'Item',
    'setting.printTemplate.fields.line_note': 'Item note',
    'setting.printTemplate.fields.unit': 'Unit',
    'setting.printTemplate.fields.quantity': 'Qty',
    'setting.printTemplate.fields.unit_price': 'Unit price',
    'setting.printTemplate.fields.return_price': 'Return price',
    'setting.printTemplate.fields.line_discount': 'Line discount',
    'setting.printTemplate.fields.line_total': 'Amount',
    'setting.printTemplate.fields.combo_groups': 'Combo groups',
    'setting.printTemplate.fields.subtotal': 'Subtotal',
    'setting.printTemplate.fields.discount': 'Discount',
    'setting.printTemplate.fields.voucher': 'Voucher code',
    'setting.printTemplate.fields.tax': 'Tax / VAT',
    'setting.printTemplate.fields.total': 'Total',
    'setting.printTemplate.fields.shipping_fee': 'Shipping fee',
    'setting.printTemplate.fields.shipping_fee_payer': 'Shipping fee payer',
    'setting.printTemplate.fields.customer_shipping_amount': 'Customer shipping amount',
    'setting.printTemplate.fields.shop_shipping_amount': 'Shop shipping amount',
    'setting.printTemplate.shippingPayer.customer': 'Customer',
    'setting.printTemplate.shippingPayer.shop': 'Shop',
    'setting.printTemplate.shippingPayer.shared': 'Shared',
    'setting.printTemplate.fields.paid_amount': 'Paid',
    'setting.printTemplate.fields.point_payment': 'Points (point count)',
    'setting.printTemplate.labels.pointPayment': 'Points ({points})',
    'setting.printTemplate.fields.debt_amount': 'Debt',
    'setting.printTemplate.fields.remaining_amount': 'Remaining',
    'setting.printTemplate.fields.payment_method': 'Payment method',
    'setting.printTemplate.fields.cod_amount': 'COD amount',
    'setting.printTemplate.fields.debt_reduced': 'Debt reduced',
    'setting.printTemplate.fields.supplier_credit': 'Supplier credit',
    'setting.printTemplate.fields.system_quantity': 'System stock',
    'setting.printTemplate.fields.actual_quantity': 'Actual quantity',
    'setting.printTemplate.fields.difference_quantity': 'Difference quantity',
    'setting.printTemplate.fields.cost_price': 'Cost price',
    'setting.printTemplate.fields.difference_value': 'Difference value',
    'setting.printTemplate.fields.item_status': 'Status',
    'setting.printTemplate.itemStatuses.matched': 'Matched',
    'setting.printTemplate.itemStatuses.different': 'Different',
    'setting.printTemplate.itemStatuses.unchecked': 'Unchecked',
    'setting.printTemplate.itemStatuses.excess': 'Excess',
    'setting.printTemplate.itemStatuses.shortage': 'Shortage',
    'setting.printTemplate.itemStatuses.draft': 'Draft',
    'setting.printTemplate.itemStatuses.balanced': 'Balanced',
    'setting.printTemplate.itemStatuses.cancelled': 'Cancelled',
    'setting.printTemplate.fields.total_items': 'Total items',
    'setting.printTemplate.fields.checked_items': 'Checked items',
    'setting.printTemplate.fields.unchecked_items': 'Unchecked items',
    'setting.printTemplate.fields.difference_quantity_total': 'Total difference quantity',
    'setting.printTemplate.fields.difference_value_total': 'Total difference value',
    'setting.printTemplate.labels.shopDefault': 'STORE',
    'setting.printTemplate.labels.address': 'Address',
    'setting.printTemplate.labels.phone': 'Phone',
    'setting.printTemplate.labels.totalProducts': 'Line count',
    'setting.printTemplate.labels.tableTransferTime': 'Time',
    'setting.printTemplate.labels.tableTransferCheckIn': 'Start time',
    'setting.printTemplate.labels.tableTransferCheckOut': 'End time',
    'setting.printTemplate.labels.tableTransferTotalMinutes': 'Total: {minutes} min',
    'setting.printTemplate.labels.tableTransferAmount': 'Table fee at transfer',
    'setting.printTemplate.labels.voucherDiscount': 'Included voucher discount',
    'setting.printTemplate.labels.splitCount': 'split {count}',
    'setting.printTemplate.labels.hour': 'hour',
    'setting.printTemplate.labels.minute': 'minutes',
    'setting.printTemplate.labels.supplierSign': 'Supplier',
    'setting.printTemplate.labels.customerSign': 'Customer',
    'setting.printTemplate.labels.creatorSign': 'Prepared by',
    'setting.printTemplate.labels.inventoryCheckSign': 'Inventory checker',
    'setting.printTemplate.labels.signNote': 'Sign and full name',
    'setting.printTemplate.labels.productionMaterials': 'Required materials',
    'setting.printTemplate.labels.warehouseSign': 'Warehouse keeper',
    'setting.printTemplate.labels.defaultBadge': 'Default',
    'setting.printTemplate.labels.customBadge': 'Customized',
    'setting.printTemplate.messages.saveSuccess': 'Print template saved',
    'setting.printTemplate.messages.resetSuccess': 'Default template restored',
    'setting.printTemplate.errors.loadFailed': 'Failed to load print templates',
    'setting.printTemplate.errors.saveFailed': 'Failed to save print template',
    'setting.printTemplate.errors.resetFailed': 'Failed to reset print template',
    'setting.printTemplate.errors.printFailed': 'Print failed',
  },
}
